module.exports = __webpack_public_path__ + "static/img/0021.1cf22ff5.png";